import {
  Button,
  Input,
  Label,
  Popover,
  PopoverContent,
  PopoverDescription,
  PopoverHeader,
  PopoverTitle,
  PopoverTrigger,
} from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function PopoverDemo() {
  return (
    <Section
      id="popover"
      title="Popover"
      description="Floating panel anchored to a trigger. Filter pickers, profile menus."
    >
      <VariantBlock label="Form popover">
        <Popover>
          <PopoverTrigger asChild>
            <Button variant="outline">Open filters</Button>
          </PopoverTrigger>
          <PopoverContent className="w-80">
            <PopoverHeader>
              <PopoverTitle>Filters</PopoverTitle>
              <PopoverDescription>
                Narrow the result list by query and date.
              </PopoverDescription>
            </PopoverHeader>
            <div className="grid gap-3">
              <div className="grid gap-1.5">
                <Label htmlFor="filter-q">Query</Label>
                <Input id="filter-q" placeholder="metricstream" />
              </div>
              <div className="grid gap-1.5">
                <Label htmlFor="filter-from">From</Label>
                <Input id="filter-from" type="date" />
              </div>
            </div>
          </PopoverContent>
        </Popover>
      </VariantBlock>

      <VariantBlock label="Alignments">
        {(["start", "center", "end"] as const).map((align) => (
          <Popover key={align}>
            <PopoverTrigger asChild>
              <Button variant="outline" size="sm" className="capitalize">
                align={align}
              </Button>
            </PopoverTrigger>
            <PopoverContent align={align} className="w-56 text-sm">
              Aligned <strong className="font-medium">{align}</strong>{" "}
              relative to the trigger.
            </PopoverContent>
          </Popover>
        ))}
      </VariantBlock>
    </Section>
  );
}
